/**
 * Single source of truth for PawPayments' own legal identity.
 *
 * These values are the counterparty details a merchant's accountant needs, so
 * they surface in three unrelated places — the legal docs, the landing page's
 * Organization JSON-LD, and the merchant dashboard's company card. Keeping one
 * copy here means a change of registration or address cannot leave one of them
 * silently stale.
 */
export const COMPANY_NAME = "PawPayments, Inc.";

export const COMPANY_ADDRESS =
    "Office 150, 145 1/2 Church Street, Unit 5, Toronto, Ontario, M5B1Y4, Canada";

/** FINTRAC Money Services Business registration number. */
export const COMPANY_MSB_REGISTRATION = "C10001337";

export const COMPANY_MSB_REGISTRATOR =
    "Financial Transactions and Reports Analysis Centre of Canada (FINTRAC)";
